import { createAction } from 'redux-actions';

import { flattenPermissions } from '@gef-ui/cdu-user/utils';

import fetch from 'features/common/fetch';
import { urls } from 'features/common/fetch/constants';

import {
	PREVIOUS_CONTEXT_USER,
	RESET_CONTEXT_USER,
	SET_CONTEXT_USER,
	SET_CONTEXT_USER_ADDITIONAL_INFO,
	SET_CONTEXT_USER_PERMISSIONS,
} from './actionTypes';
import { getContextUser } from './selectors';

export const setContextUser = createAction(SET_CONTEXT_USER);

export const setContextUserPermissions = createAction(SET_CONTEXT_USER_PERMISSIONS, (permissions) => ({ permissions }));
export const setContextUserAdditionalInfo = createAction(SET_CONTEXT_USER_ADDITIONAL_INFO, (additionalInfo) => ({
	additionalInfo,
}));

export const reset = createAction(RESET_CONTEXT_USER);

export const previous = createAction(PREVIOUS_CONTEXT_USER);

export const fetchContextUserInfo = () => (dispatch, getState) => {
	const contextUser = getContextUser(getState());

	dispatch(
		fetch.actions.get(urls.appUser, {
			uniqueReqID: 'contextUserInfo',
			queryParams: { login: contextUser.login },
			onSuccess: [
				(response) => () => {
					if (!response.body) return;
					const { permissions } = response.body;
					const flattenedPermissions = flattenPermissions(permissions);
					dispatch(setContextUserPermissions(flattenedPermissions));
				},
			],
		}),
	);
};

export const fetchAdditionalContextUserInfo = (contextUser) => (dispatch) =>
	dispatch(
		fetch.actions.get(fetch.constants.urls.userRoles, {
			queryParams: {
				login: contextUser.login,
			},
			onSuccess: [
				(response) => () => {
					dispatch(setContextUserAdditionalInfo(response.body));
				},
			],
		}),
	);
